import { useRouteUrl } from '@confluence/route-manager/entry-points/RouteState.ts';
import { TEMPLATE_GALLERY, HOME } from '@confluence/named-routes/entry-points/routes.ts';

import type { MenuId } from '../PlatformNavigationTypes.ts';

type RouteMatcherType = {
	pattern: string;
	menuId: MenuId;
};

// Pattern matchers for determining which menuid should be associated with the current route.
const ROUTE_MATCHERS: RouteMatcherType[] = [
	{ pattern: TEMPLATE_GALLERY.toUrl(), menuId: 'templates' },
	{ pattern: HOME.toUrl({ view: 'drafts' }), menuId: 'drafts' },
	{ pattern: HOME.toUrl({ view: 'tasks' }), menuId: 'tasks' },
	{ pattern: HOME.toUrl({ view: 'marketplace' }), menuId: 'apps' },
];

export const useActiveRoute = (): MenuId | undefined => {
	return useRouteUrl({
		selector: (routeUrl: string | undefined) =>
			routeUrl
				? ROUTE_MATCHERS.find(({ pattern }) => routeUrl.includes(pattern))?.menuId
				: undefined,
	});
};
